import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { addSelectedActivity, removeActivity, resetSelections, setActivityEditMode, setColumnMessage, setCurrentStep, setIsStepFourLoading, setLastEditedActivityCampaignId, setOpportunity, setOpportunityProduct, setPaymentCountDown, setSelectedActivity, setVisitors } from "../../store/MahutiReducer";
import { PAGES, PREFIX_PATH } from "../../utils/GlobalParams";
import { mySteps } from "../../utils/stepperUtils";
import './CartActivityItem.css'
import { deleteActivity } from "../../utils/sfUtils";
import { ClearLocalStorage } from "../../store/mahutiLocalStorage";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import {clearAll, fixDateDirection} from "../../utils/orderUtils";
export default function CartActivityItem(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const productIdentifier = props.campaignId
    const productVisitors = props.visitors
    const selectedActivity = props.store.selectedActivities[props.index]
    const store = useSelector(state => state.reducer);
    let lpPrefix = store.lpName ? '/' + store.lpName : '';

    const editSelectedActivity = (e) => {
        e.preventDefault();
        props.dispatch(setVisitors({underAge: selectedActivity.visitors.underAge, adults: selectedActivity.visitors.adults}))
        navigate(PREFIX_PATH + lpPrefix + '/' + PAGES.ACTIVITY_FLOW);
        props.dispatch(setCurrentStep(0));
        props.dispatch(setLastEditedActivityCampaignId(props.campaignId))
        props.dispatch(setSelectedActivity(props.store.selectedActivities[props.index]))
        props.dispatch(setActivityEditMode(productIdentifier));
        props.dispatch(setPaymentCountDown(undefined))
    }

    const removeItemHandler = async (e) => {
        e.preventDefault();
        mySteps[props.store.currentStep].disabled = true;
        let opportunityProductIndex = props.store.opportunityProduct.findIndex(item => {
            return item.campaignId === productIdentifier && item.adults === productVisitors.adults && item.underAge === productVisitors.underAge
        })
        let selectedActivityIndex = props.store.selectedActivities.findIndex(item => {
            return item.campaignId === productIdentifier && item.adults === productVisitors.adults && item.underAge === productVisitors.underAge
        })
        let lastDeletedActivity = props.store.selectedActivities[selectedActivityIndex]
        try{
            console.log(selectedActivityIndex)
            console.log(productVisitors)
            props.dispatch(setIsStepFourLoading(true));
            props.dispatch(removeActivity({campaignId: productIdentifier, adults: productVisitors.adults, underAge: productVisitors.underAge}))
            let res = await deleteActivity(props.store.opportunityProduct[opportunityProductIndex].opportunityProduct, props.store.opportunity.id)

            let newOPArray = [...props.store.opportunityProduct]
            newOPArray.splice(opportunityProductIndex, 1)
            props.dispatch(setOpportunityProduct(newOPArray))

            props.dispatch(setOpportunity({ amount: res.data.Newamount, discount: res.data.Discount }));
            props.dispatch(setIsStepFourLoading(false));
            if (props.store.selectedActivities.length === 1 || !props.store.selectedActivities) {
                props.dispatch(setOpportunity())
                props.dispatch(setPaymentCountDown(undefined))
                props.dispatch(resetSelections())
                clearAll(props.dispatch) //test cache bug
                ClearLocalStorage()
                navigate(PREFIX_PATH + lpPrefix + '/');
            }
        }catch(err){
            console.log(err) 
            props.dispatch(setColumnMessage({...store.columnMessage, alert: 'היתה תקלה במחיקה מהסל'}))
            props.dispatch(addSelectedActivity(lastDeletedActivity))
            props.dispatch(setIsStepFourLoading(false));    
        }
    }
    return <div className="cartActivityItem card pb-3 p-lg-2">
                <div className={`${props.isDisable ? 'disabled ' : ''} ${!isMobile ? '' : ''}`}>
                    <div className="row gx-lg-4 gx-3">
                        <div className="col-3 col-lg-3">
                            <img className=" card-img border-0" src={props.cartImage} />
                        </div>
                        <div className="col-9 col-lg-9">
                            <div className="details row text-mahuti cart_cust_design">
                                <div className="col text-start text-mahuti ">{props.Title || '--'}</div>
                                <div className="col text-end">
                                {/* Make the container focusable */}
                                <div tabIndex={0} aria-label={`${props.timing?.startTime} עד ${props.timing?.endTime}` || '--'}>
                                    {/* Visible text for sighted users */}
                                    {`${props.timing?.endTime} - ${props.timing?.startTime}` || '--'}
                                </div>
                                </div>
                                <div className="w-100"></div>
                                {!props.isGenericEvent && <>
                                    <div className="col text-start">{props?.visitors?.underAge || '--'} x ילד</div>
                                    <div className="col text-end">{props.price?.underAge || '--'}₪</div>
                                    <div className="w-100"></div>
                                </>}
                                <div className="col text-start">{props?.visitors?.adults || '--'} x מבוגר</div>
                                <div className="col text-end">{props.price?.adults || '--'}₪</div>
                                <div className="w-100"></div>
                                <div className="col text-start">{fixDateDirection(props.activityDate)}</div>
                                <div id='payment' className="col text-end" dir="ltr">{(props.price?.underAge * props.visitors?.underAge || 0) + (props.visitors?.adults * props.price?.adults || 0) + '₪'} :לתשלום </div>

                            </div>
                        </div>

                    </div>


                    <div className="row">
                        <div className="item-btns text-end ">
                            {/* <a href="/" onClick={editSelectedActivity} className={"btn-link  p-1" + (props.isDisable ? ' isDisabled' : '')}>עריכה</a> */}
                            <a 
                                href="/" 
                                onClick={(e) => removeItemHandler(e)} 
                                className={"btn-link text-decoration-none align-middle" + (props.isDisable ? ' isDisabled' : '')}
                                aria-label={`הסרת פעילות ${props.Title || 'לא ידוע'}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                                    <path d="M7.47277 1.38096V1.57596H7.66777H9.41045C9.88105 1.57596 10.2611 1.95502 10.2611 2.41668C10.2611 2.78711 10.0164 3.10454 9.67536 3.21538L9.55211 3.25544L9.54131 3.38459L8.91969 10.8179C8.91969 10.818 8.91969 10.818 8.91969 10.818C8.88346 11.2482 8.51164 11.5892 8.07198 11.5892H2.38407C1.94442 11.5892 1.57261 11.2482 1.53641 10.8182C1.53641 10.8182 1.53641 10.8181 1.53641 10.8181L0.914744 3.38461L0.903944 3.25547L0.780701 3.21541C0.439623 3.10455 0.195 2.78711 0.195 2.41668C0.195 1.95502 0.575003 1.57596 1.04561 1.57596H2.78828H2.98328V1.38096V1.03572C2.98328 0.574061 3.36328 0.195 3.83389 0.195H6.62217C7.09277 0.195 7.47277 0.574061 7.47277 1.03572V1.38096ZM6.9707 1.57596H7.1657V1.38096V1.03572C7.1657 0.735915 6.92029 0.495479 6.62217 0.495479H3.83389C3.53576 0.495479 3.29035 0.735915 3.29035 1.03572V1.38096V1.57596H3.48535H6.9707ZM8.61362 10.7935L8.61363 10.7934L9.22617 3.46864L9.24383 3.25739H9.03185H1.42421H1.21222L1.22989 3.46864L1.84247 10.7935L1.84248 10.7936C1.86599 11.0736 2.10449 11.2887 2.38407 11.2887H8.07198C8.35166 11.2887 8.59005 11.0735 8.61362 10.7935ZM1.04561 2.95691H9.41045C9.70858 2.95691 9.95398 2.71648 9.95398 2.41668C9.95398 2.11687 9.70858 1.87644 9.41045 1.87644H1.04561C0.747479 1.87644 0.50207 2.11687 0.50207 2.41668C0.50207 2.71648 0.747479 2.95691 1.04561 2.95691Z" fill="#F04D81" stroke="#F04D81" strokeWidth="0.39"/>
                                    <path d="M3.12715 4.33813L3.12705 4.33813C3.04074 4.34344 2.97833 4.41626 2.98338 4.49725C2.98338 4.49726 2.98338 4.49726 2.98338 4.49727L3.33192 10.0671C3.3368 10.1452 3.40292 10.2082 3.48484 10.2082C3.57583 10.2082 3.64368 10.1331 3.63843 10.0488L3.12715 4.33813ZM3.12715 4.33813C3.21282 4.33282 3.28481 4.39791 3.28989 4.47889C3.28989 4.4789 3.28989 4.4789 3.28989 4.4789L3.63842 10.0487L3.12715 4.33813Z" fill="#F04D81" stroke="#F04D81" strokeWidth="0.39"/>
                                    <path d="M5.07537 4.48806C5.07537 4.40684 5.14237 4.33782 5.22891 4.33782C5.31545 4.33782 5.38244 4.40684 5.38244 4.48806V10.0579C5.38244 10.1391 5.31545 10.2082 5.22891 10.2082C5.14237 10.2082 5.07537 10.1391 5.07537 10.0579V4.48806Z" fill="#F04D81" stroke="#F04D81" strokeWidth="0.39"/>
                                    <path d="M7.3292 4.33813L7.32926 4.33813C7.41552 4.34342 7.47795 4.41622 7.4729 4.49725C7.4729 4.49725 7.4729 4.49726 7.47289 4.49726L7.12436 10.0671L7.12436 10.0671C7.11929 10.1483 7.04801 10.2132 6.96149 10.2079C6.87525 10.2025 6.81282 10.1297 6.81785 10.0487C6.81785 10.0487 6.81785 10.0487 6.81786 10.0487L7.16639 4.47889L7.16639 4.47887C7.17146 4.39782 7.24307 4.33282 7.3292 4.33813Z" fill="#F04D81" stroke="#F04D81" strokeWidth="0.39"/>
                                </svg> הסרה</a>
                        </div>
                    </div>
                </div>






    </div>
}